import { Flex, Select, Text, Checkbox } from '@backstage/ui';
import { useSearch } from '@backstage/plugin-search-react';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';
import { appTranslationRef } from '../../../../core/i18n';
import styles from './search-filters.module.css';

const lifecycleValues = ['experimental', 'production'];

export const SearchFilters = () => {
  const { filters, setFilters } = useSearch();
  const { t } = useTranslationRef(appTranslationRef);

  const kindOptions = [
    { value: '', label: t('catalog.filters.all') },
    { value: 'Component', label: t('search.filters.component') },
    { value: 'Template', label: t('search.filters.template') },
  ];

  const handleLifecycleChange = (value: string, checked: boolean) => {
    const current = (filters.lifecycle as string[]) || [];
    const updated = checked
      ? [...current, value]
      : current.filter(v => v !== value);
    setFilters(prev => ({
      ...prev,
      lifecycle: updated.length > 0 ? updated : undefined,
    }));
  };

  return (
    <Flex direction="column" gap="4">
      <Select
        label={t('search.filters.kind')}
        options={kindOptions}
        defaultValue={(filters.kind as string) || ''}
        onChange={value => {
          const selected = value as string;
          setFilters(prev => ({
            ...prev,
            kind: selected || undefined,
          }));
        }}
      />

      <Flex direction="column" gap="1">
        <Text
          variant="body-x-small"
          color="secondary"
          weight="bold"
          className={styles.sectionLabel}
        >
          {t('search.filters.lifecycle')}
        </Text>
        <Flex direction="column" gap="2">
          {lifecycleValues.map(value => {
            const currentLifecycle = (filters.lifecycle as string[]) || [];
            const isChecked = currentLifecycle.includes(value);
            return (
              <Checkbox
                key={value}
                isSelected={isChecked}
                onChange={checked => handleLifecycleChange(value, checked)}
              >
                {t(`search.filters.${value}` as 'search.filters.experimental')}
              </Checkbox>
            );
          })}
        </Flex>
      </Flex>
    </Flex>
  );
};
